import { trackEvent, HeapEvents } from '../../../../services/util/AnalyticsUtil';
import { TicketState } from '../../services/TicketState';
import ticketsApi from '../../../../services/api/ticketsApi';

/* Service class used to perform api calls for retrieving employees/tax pros */
class TicketService {

    constructor() {
        this.api = ticketsApi.create();
    }

    async assignTicket(ticketId, associateId, officeId, failoninvalidassignment, overwriteassignment) {
        var data = await this.bulkAssignTickets([ticketId], associateId, officeId, failoninvalidassignment, overwriteassignment);
        return data[0];
    }

    async openAndAssignTicket(ticketId, associateId) {
        let payload = {
            associateId: associateId,
            ticketState: TicketState.OPEN
        }

        let response = await this.api.openAndAssignTicket(ticketId, payload);
        if (response && response.status === 200) {
            trackEvent(HeapEvents.REOPEN_TICKET, ticketId, { associateId: associateId });
            return response.data;
        }
    }

    async bulkAssignTickets(ticketIds, associateId, associateOfficeId, failoninvalidassignment, overwriteassignment) {
        let payload = {
            ticketIds: ticketIds,
            officeId: associateOfficeId,
            failoninvalidassignment: failoninvalidassignment,
            overwriteassignment: overwriteassignment
        }

        let response = await this.api.assignTickets(associateId, payload);
        if (response && response.status === 200) {
            ticketIds.forEach(async (ticketId) => {
                trackEvent(HeapEvents.REASSIGN_TICKET, ticketId, { associateId: associateId });
            });
            return response.data
        }
    }
}

const ticketService = new TicketService();
export default ticketService;